import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import {
  FormFieldComponentProps,
  VerificationServiceProps,
  Country,
  FormSelectChoice,
} from "../../../lib/types/types";
import { getSafe } from "../../../lib/utils/objects";
import { FormFieldTypeahead } from "../FormFieldTypeahead/FormFieldTypeahead";

export const Company = ({
  onChange,
  value,
  isErrored,
  verificationService,
  intl,
  placeholder = "",
}: FormFieldComponentProps & VerificationServiceProps) => {
  const { programId } = verificationService;
  const htmlId = "company";
  const country = getSafe<Country>(() => verificationService.viewModel.countryChoice.value);

  return (
    <FormFieldTypeahead
      fieldId={htmlId}
      value={value}
      onChange={(choice: FormSelectChoice) => onChange(choice)}
      country={country}
      placeholder={
        placeholder ||
        intl.formatHTMLMessage({ id: "companyPlaceholder", defaultMessage: "Company" })
      }
      programId={programId}
      label={<FormattedHTMLMessage id="company" defaultMessage="Company" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidOrganization"
            defaultMessage="You must select an organization from the list"
          />
        )
      }
      verificationService={verificationService}
      showPlaceholderAndHideLabel={!!placeholder}
    />
  );
};

export const CompanyComponent = injectIntl(Company);
